import { SVGProps } from "react";

const IconBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0667 20.0775V16.1172C11.0667 16.1172 11.481 16.1172 12 16.1172C12.5154 16.1172 12.9333 16.1172 12.9333 16.1172V20.0775H14.7998V12.5447H9.20023V20.0775H11.0667ZM3.60068 12.2951C2.66742 12.2951 2.66742 12.2951 2.66742 12.2951C2.66742 12.2951 2.66742 11.0375 2.66742 10.6736V9.72908C1.99395 9.72908 1.5 9.72908 1.5 9.72908C1.5 9.72908 1.5 9.15257 1.5 8.61719L11.2284 3.33276C11.6545 3.04526 12.3453 3.04538 12.771 3.33282L22.5 8.61719C22.5 9.14583 22.5 9.73029 22.5 9.73029C22.5 9.73029 21.9456 9.73029 21.3326 9.73029V10.6736C21.3326 11.0177 21.3326 12.2937 21.3326 12.2937C21.3326 12.2937 20.7969 12.2937 20.3993 12.2937V20.0775H22.6437C22.6437 20.3747 22.6437 20.4917 22.6437 21.0107C22.6437 21.5261 22.6437 21.5689 22.6437 21.944H1.5C1.5 21.7291 1.5 21.5297 1.5 21.0107C1.5 20.4953 1.5 20.6172 1.5 20.0775H3.60068V12.2951ZM11.0667 7.87838C11.5 7.87838 11.481 7.87838 12 7.87838C12.5154 7.87838 12.7043 7.87838 12.9333 7.87838H17.597L12 5.06889L6.40216 7.87838H11.0667ZM5.4672 12.5447V20.0775H7.33371V12.5447H5.4672ZM16.6663 12.5447V20.0775H18.5328V12.5447H16.6663ZM4.53394 9.74489V10.6782H19.4661V9.74489H4.53394Z"
      fill="#303D49"
    />
  </svg>
);

export default IconBank;
